import React, { Component } from 'react';
import classes from "./styles.module.scss";

interface IProp {
  onClick?: Function
}

export default class Button extends Component<IProp> {

  render() {
    return (
      <div
        className={classes.Button}
        onClick={() => this.props.onClick ? this.props.onClick() : false}
      >{this.props.children}</div>
    )
  }
}